import { CloseOutlined, RightOutlined, SearchOutlined } from '@ant-design/icons'
import { T } from '@transifex/react'
import { CSSProperties } from 'styled-components'
import React, {
  MutableRefObject,
  ReactNode,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'
import { Typography } from 'src/storybook/components'
import { Button, Col, Row, Space } from 'src/antd'

export type TSearchTogglerProps = {
  children: ReactNode
  initOpen?: boolean
  onVisibleChange?: (state: boolean) => void
  disableClose?: boolean
  style?: CSSProperties
}

const SearchToggler = ({
  disableClose,
  children,
  onVisibleChange,
  initOpen = false,
  style,
}: TSearchTogglerProps) => {
  const wrapperRef =
    useRef<HTMLDivElement>() as MutableRefObject<HTMLDivElement>
  const [showSearch, setShowSearch] = useState(initOpen)

  const toggleSearch = useCallback((curr: boolean) => {
    if (curr) {
      // set to false
      setShowSearch(false)
    } else {
      // set search to true
      setShowSearch(true)
    }
  }, [])

  useEffect(() => {
    onVisibleChange?.(showSearch)
  }, [showSearch, onVisibleChange])

  return (
    <div style={style} ref={wrapperRef}>
      {!showSearch && (
        <Button
          onClick={() => toggleSearch(showSearch)}
          type="text"
          icon={<SearchOutlined />}
        >
          <span>
            <Space>
              <Typography weight="semi-bold">
                <T _str="Search" />
              </Typography>
              <RightOutlined style={{ color: 'rgb(191, 191, 191)' }} />
            </Space>
          </span>
        </Button>
      )}
      <Row
        style={{ display: showSearch ? 'flex' : 'none' }}
        align="middle"
        gutter={8}
        wrap={false}
      >
        <Col flex="auto">{children}</Col>
        {!disableClose && (
          <Col style={{ width: 50 }} className="whf-center-child">
            <Row style={{ width: '100%' }} justify="start">
              <Button
                onClick={() => toggleSearch(showSearch)}
                type="text"
                ghost
                icon={<CloseOutlined />}
                size="small"
              />
            </Row>
          </Col>
        )}
      </Row>
    </div>
  )
}

export default SearchToggler
